import { TextFieldProps } from "@mui/material";
import { forwardRef, useEffect, useState } from "react";

import { AutocompleteModel } from "~/__generated__";

import useAutocompleteGetOptions from "../../../api/useAutocompleteGetOptions";
import GaiaOptionsDropdown from "../../GaiaOptionsDropdown";

type Props = {
    model: AutocompleteModel;
    value?: string;
    onChange?: (value: string) => void;
} & TextFieldProps;

const GaiaAutocompleteOptionsDropdown = forwardRef<HTMLDivElement, Props>(
    ({ model, value, onChange, ...rest }, ref) => {
        const { data, loading, error } = useAutocompleteGetOptions({ model });
        const [availableOptions, setAvailableOptions] = useState<string[]>([]);

        useEffect(() => {
            if (data) {
                setAvailableOptions(data.map(option => option.value));
            }
        }, [data]);

        return (
            <GaiaOptionsDropdown
                options={data!}
                disabled={loading || !!error}
                value={availableOptions.includes(value!) ? value : ""}
                onChange={selectedValue => {
                    setAvailableOptions(prev => [...new Set([...prev, String(selectedValue)])]);
                    if (onChange) onChange(selectedValue);
                }}
                ref={ref}
                {...rest}
            />
        );
    },
);

export default GaiaAutocompleteOptionsDropdown;
